/**
 * @generated SignedSource<<69d12dc5d14453f32c10f7bcceb25e06>>
 * @relayHash ff9a0a266644264fc112ab75645ba344
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cd2455e31cf4bbe8670ba9b066541c2e9f89ea9f44f11b91969fd55008ba8802

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "cd2455e31cf4bbe8670ba9b066541c2e9f89ea9f44f11b91969fd55008ba8802",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
